import React from 'react';
import Isvg from "react-inlinesvg";
import Button from "../Button";
import LocaleText from "../LocaleText";
import PropTypes from "prop-types";

class BrowserDetectPopUp extends React.Component {
    constructor() {
        super();
        this.detectIE = this.detectIE.bind(this);
    }

    detectIE() {
        // source: https://stackoverflow.com/a/49328524
        // Internet Explorer 6-11
        const isIE = /*@cc_on!@*/false || !!document.documentMode;

        if(isIE) {
            this.props.toggle();
        }
    }

    componentDidMount() {
        this.detectIE();
    }

    render() {
        const { isOpen, extraClasses, toggle } = this.props;
        const classes = ['browser-detect-popup'].concat(extraClasses);
        if (isOpen) {
            classes.push('is-open');
        } else {
            return null;
        }
        return (
            <div className={classes.join(' ')}>
                <div className="browser-detect-popup__body">
                    <div className="browser-detect-popup__inner">
                        {toggle && (
                            <div className="close-icon" onClick={toggle}>
                                <Isvg src="../../svg/cancel.svg" />
                            </div>
                        )}
                        {this.props.children}
                    </div>
                </div>
            </div>
        );
    }
}

BrowserDetectPopUp.propTypes = {
    isOpen: PropTypes.bool,
    toggle: PropTypes.func,
    extraClasses: PropTypes.array,
};

BrowserDetectPopUp.defaultProps = {
    isOpen: false,
    extraClasses: [],
    toggle: undefined,
};

export default BrowserDetectPopUp;